var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_2169_30791)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 80,
    height: 80,
    rx: 24,
    fill: "#4EB77B"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dd_2169_30791)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.5004 19.7157C56.1203 21.8058 59.1316 24.805 61.2361 28.4165C63.3406 32.0279 64.4655 36.1264 64.4992 40.3062C64.533 44.4859 63.4745 48.602 61.4286 52.247C59.3827 55.892 56.4203 58.9394 52.8346 61.0877C49.249 63.236 45.1644 64.4105 40.9853 64.4951C36.8062 64.5797 32.6775 63.5713 29.0079 61.5699C25.3383 59.5685 22.255 56.6434 20.0632 53.0842C17.8715 49.525 16.6474 45.455 16.512 41.2773L16.5 40.4997L16.512 39.7221C16.6464 35.5773 17.8525 31.538 20.0128 27.9981C22.173 24.4582 25.2137 21.5384 28.8383 19.5235C32.4629 17.5085 36.5478 16.4671 40.6947 16.5008C44.8416 16.5345 48.909 17.6421 52.5004 19.7157ZM49.3972 34.0029C48.9839 33.5897 48.4341 33.3415 47.8508 33.3048C47.2675 33.2681 46.6909 33.4455 46.2292 33.8037L46.0036 34.0029L38.1003 41.9037L34.997 38.8029L34.7714 38.6037C34.3096 38.2458 33.7331 38.0686 33.15 38.1054C32.5668 38.1422 32.0172 38.3904 31.604 38.8036C31.1909 39.2167 30.9426 39.7664 30.9058 40.3495C30.869 40.9326 31.0462 41.5091 31.4042 41.9709L31.6034 42.1965L36.4034 46.9965L36.629 47.1957C37.0499 47.5223 37.5675 47.6995 38.1003 47.6995C38.633 47.6995 39.1506 47.5223 39.5715 47.1957L39.7971 46.9965L49.3972 37.3965L49.5964 37.1709C49.9546 36.7092 50.132 36.1326 50.0953 35.5493C50.0587 34.966 49.8104 34.4162 49.3972 34.0029Z",
    fill: "url(#paint0_linear_2169_30791)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1043 33.2959L50.1043 33.2958C49.5188 32.7104 48.7399 32.3587 47.9136 32.3068C47.0873 32.2548 46.2704 32.5061 45.6162 33.0136C45.5995 33.0266 45.5832 33.0401 45.5673 33.0541L45.3417 33.2533C45.3262 33.267 45.3112 33.2811 45.2966 33.2957L38.1001 40.4899L35.7039 38.0956C35.6893 38.081 35.6743 38.0669 35.6589 38.0533L35.4333 37.8541C35.4173 37.84 35.4009 37.8264 35.3841 37.8134C34.7298 37.3063 33.9131 37.0553 33.087 37.1074C32.2609 37.1595 31.4822 37.5112 30.8969 38.0965C30.3116 38.6817 29.9599 39.4605 29.9078 40.2865C29.8557 41.1126 30.1067 41.9294 30.6138 42.5836C30.6269 42.6004 30.6405 42.6168 30.6546 42.6328L30.8538 42.8584C30.8675 42.8739 30.8817 42.889 30.8963 42.9036L35.6963 47.7036C35.711 47.7183 35.7261 47.7325 35.7416 47.7461L35.9672 47.9453C35.983 47.9594 35.9993 47.9729 36.0161 47.9858C36.6123 48.4484 37.3456 48.6995 38.1003 48.6995C38.855 48.6995 39.5882 48.4484 40.1845 47.9858C40.2012 47.9729 40.2175 47.9594 40.2334 47.9453L40.459 47.7461C40.4745 47.7325 40.4896 47.7183 40.5042 47.7036L50.1043 38.1036C50.1189 38.089 50.1331 38.0739 50.1468 38.0584L50.346 37.8328C50.36 37.8169 50.3736 37.8006 50.3865 37.7839C50.894 37.1297 51.1453 36.3128 51.0934 35.4866C51.0414 34.6603 50.6897 33.8813 50.1043 33.2959ZM52.0004 20.5818C55.4695 22.5847 58.3553 25.459 60.3721 28.9199C62.3889 32.3809 63.4669 36.3086 63.4992 40.3142C63.5316 44.3198 62.5172 48.2644 60.5566 51.7575C58.5959 55.2507 55.7569 58.1711 52.3207 60.2299C48.8844 62.2886 44.9701 63.4142 40.9651 63.4953C36.9601 63.5763 33.0034 62.61 29.4867 60.692C25.97 58.774 23.0151 55.9707 20.9147 52.5598C18.8158 49.1513 17.6429 45.254 17.5117 41.2533L17.5001 40.4997L17.5117 39.7462C17.6419 35.777 18.7976 31.9091 20.8664 28.519C22.9366 25.1266 25.8506 22.3285 29.3242 20.3975C32.7978 18.4665 36.7125 17.4685 40.6866 17.5008C44.6607 17.5331 48.5587 18.5945 52.0004 20.5818Z",
    stroke: "url(#paint1_linear_2169_30791)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    shapeRendering: "crispEdges"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_2169_30791",
    x: 0.5,
    y: -3.5,
    width: 80,
    height: 84,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2169_30791"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_innerShadow_2169_30791"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_2169_30791",
    result: "effect2_innerShadow_2169_30791"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dd_2169_30791",
    x: 8.5,
    y: 12.5,
    width: 64,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2169_30791"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2169_30791",
    result: "effect2_dropShadow_2169_30791"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2169_30791",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2169_30791",
    x1: 40.5,
    y1: 16.5,
    x2: 40.5,
    y2: 64.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2169_30791",
    x1: 40.5,
    y1: 16.5,
    x2: 40.5,
    y2: 64.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/success_icon.d04aef44462d9331b9800b34386bec80.svg";
export { ForwardRef as ReactComponent };